export const SPLASH_ROOT_ATTRIBUTE = 'data-splash-root';
